import { unauthenticatedPost } from '@/api/handlers';
import { useMutation } from '@/api/hooks';
import { useInvalidateQuery } from '@/hooks';
import type { MutationConfig } from '@/lib/react-query';
import { useCookies } from 'react-cookie';

import { LoginModel } from '../_models/login';
import { authenticationQueryKeyMap } from '../_utils/query-keys';

const login = async (data: { email: string; password: string }) => {
  const res = await unauthenticatedPost('/api/login/', data);
  return LoginModel.parse(res);
};

type UseLogin = {
  config?: MutationConfig<typeof login>;
};

export const useLogin = ({ config }: UseLogin = {}) => {
  const [, setCookie] = useCookies();
  const { invalidate } = useInvalidateQuery();
  return useMutation(
    {
      ...config,
      mutationFn: async (data: { email: string; password: string }) => {
        const res = await unauthenticatedPost('/api/login/', data);
        const parsed = LoginModel.parse(res);
        setCookie('access_token', parsed.access, { path: '/' });
        await invalidate(authenticationQueryKeyMap.me());
        return parsed;
      },
    },
    true,
  );
};
